var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 14.6668C7.80001 14.6668 7.60001 14.6668 7.40001 14.6668C3.73334 14.2668 1.00001 11.0002 1.33334 7.3335C1.60001 4.1335 4.13334 1.60016 7.33334 1.3335C7.60001 1.3335 7.86668 1.46683 8.00001 1.66683C8.13334 1.86683 8.13334 2.20016 7.93334 2.40016C6.66668 4.20016 7.06668 6.66683 8.80001 8.00016C10.2 9.06683 12.1333 9.06683 13.5333 8.00016C13.7333 7.86683 14 7.80016 14.2667 7.9335C14.4667 8.06683 14.6 8.3335 14.6 8.60016C14.4667 10.4002 13.6 12.0002 12.2 13.1335C11.0667 14.1335 9.53334 14.6668 8.00001 14.6668ZM6.20001 2.9335C4.26668 3.60016 2.86668 5.3335 2.73334 7.46683C2.46668 10.4002 4.60001 13.0002 7.53334 13.2668C8.93334 13.4002 10.3333 13.0002 11.4 12.0668C12.1333 11.4668 12.6667 10.6668 13 9.80016C11.3333 10.4002 9.46668 10.1335 8.00001 9.06683C6.06668 7.60016 5.40001 5.1335 6.20001 2.9335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.6a30b72a.svg";
export { ForwardRef as ReactComponent };